import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreIssueTypesWorkflowRoute: InvariantJiraRoute = {
	name: 'project-settings-core-issuetypes-workflow',
	path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
	exact: true,
};
